import { techStack } from '../data/techStack.js';
import SectionHeading from './shared/SectionHeading.jsx';
import SectionReveal from './shared/SectionReveal.jsx';

export default function TechStack() {
  return (
    <section id="tech" className="section-pad relative">
      <div className="container-x">
        <SectionHeading
          eyebrow="Our stack"
          title="Battle-tested tools, chosen for the long haul."
          subtitle="We default to proven, well-supported technology — and reach for the cutting edge only where it earns its keep."
        />

        <div className="mt-16 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {techStack.map((tech, i) => (
            <SectionReveal
              key={tech.id}
              delay={i * 90}
              className="group relative h-full"
            >
              <div className="relative flex h-full flex-col items-center overflow-hidden rounded-2xl glass p-6 text-center transition-all duration-500 ease-smooth-out hover:-translate-y-1 hover:border-cyan/40 hover:shadow-card-hover">
                {/* Logo glyph */}
                <div className="relative grid h-20 w-20 place-items-center">
                  <div className="absolute inset-0 rounded-full bg-gradient-to-br from-cyan/15 to-navy-500/20 opacity-0 blur-md transition-opacity duration-500 group-hover:opacity-100" />
                  <span className="relative grid h-16 w-16 place-items-center rounded-2xl border border-white/10 bg-navy-800/60 font-heading text-3xl font-extrabold text-silver-light transition-all duration-500 group-hover:scale-110 group-hover:border-cyan/40 group-hover:text-cyan">
                    {tech.glyph}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-semibold text-white">{tech.name}</h3>
                <span className="mt-1 text-[11px] font-medium uppercase tracking-wider text-cyan/70">
                  {tech.category}
                </span>

                {/* Hover description */}
                <div className="mt-3 max-h-0 overflow-hidden opacity-0 transition-all duration-500 ease-smooth-out group-hover:max-h-32 group-hover:opacity-100">
                  <p className="text-xs leading-relaxed text-silver/70">{tech.description}</p>
                </div>
              </div>
            </SectionReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
